/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Italics_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where all lines are italicized" |
*
* @param {Style_Guide_Manager_Italics_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_italics_tooltip = /** @type {((inputs?: Style_Guide_Manager_Italics_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Italics_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou toutes les lignes sont en italique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie auf Ereignisse, bei denen alle Zeilen kursiv sind.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla gli eventi in cui tutte le righe sono in corsivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте события, в которых все строки выделены курсивом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobar eventos donde todas las líneas están en cursiva")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查所有行都为斜体的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての行が斜体になっているイベントをチェックする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन घटनाओं की जाँच करें जहाँ सभी पंक्तियाँ इटैलिक में लिखी गई हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que todas as linhas estão em itálico.")
	return /** @type {LocalizedString} */ ("Check for Events where all lines are italicized")
});